import { Navigate, Route, Routes, useParams } from "react-router-dom"
import EventsList from "./list"
import ShowEvent from "./show"
import Accident from "./show/accident"
import Registration from "./subscirptionsActivities"
import ShowActivity from "./subscirptionsActivities/show"
import NoMatch from "components/no-match"

const Events: React.FC = () => (
  <Routes>
    <Route index element={<Navigate to="subscriptions" replace />} />
    <Route path=":eventsTab" element={<EventsList />} />
    <Route path="show/:eventId" element={<ShowEvent />} />
    <Route path="show/:eventId/accident/:accidentId" element={<Accident />} />
    <Route path="registration/*">
      <Route index element={<Registration />} />
      <Route path="show/:activityId" element={<ShowActivity />} />

      <Route path="*" element={<NoMatch />} />
    </Route>

    <Route path="*" element={<NoMatch />} />
  </Routes>
)

function useEventsTab() {
  return useParams<"eventsTab">().eventsTab as
    | "subscriptions"
    | "presubscriptions"
    | "waiting_list"
    | "history"
}

function useEventId() {
  return useParams<"eventId">().eventId
}

function useAccidentId() {
  return useParams<"accidentId">().accidentId
}

function useActivityId() {
  return useParams<"activityId">().activityId
}

export { useEventsTab, useEventId, useAccidentId, useActivityId }

export default Events
